import { useInfiniteQuery, useMutation } from 'react-query';

import { PageRequest } from '@/core/request/PageRequest';

import { ListBankSlipQuery } from './Omie.types';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';
import serviceInternoOmie from './Omie.service';

export function useBankSlips(params?: ListBankSlipQuery) {
  return useInfiniteQuery(
    ['companies', { ...params }],
    async ({ pageParam }) => {
      const req: PageRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return await serviceInternoOmie.listBankSlips(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useRetrieveBankSlip() {
  return useMutation({
    mutationFn: serviceInternoOmie.retrieveBankSlip,
    onError(error) {
      notificationError(error);
    },
  });
}
